import React, { useState, useEffect, useRef, useCallback } from 'react'
import { CreateTitle, CreateDetails, CreateImageSubTitle } from './until'
import Bookbank from '../image/Bookbank.svg'
import Button from '../../../common-components/button'
import { handleDeviceDetection, device_type } from '../ActionHelper'
import { ModalHeader, ModalBody, ModalFooter, Modal } from 'reactstrap'
import iconCamara from '../image/iconCamara.svg'
import { state_action } from '../ActionHelper'
import _ from 'lodash'

const ConsentAllow = ({ onNextPage, payerModalSelcted, typemodal }) => {
  const [mainModal, setMainModal] = useState(false)
  const contentRef = useRef(null)
  const WindowHeight = parseInt(window.innerHeight * 0.75) + 'px'
  const [isChecked, setIsChecked] = useState(false)
  const fileInputRef = useRef(null)

  const toggleMainModal = () => setMainModal(!mainModal)
  const toggleNestedModal = () => {
    setIsChecked(true)
    setMainModal(false)
  }

  const [scrollDirection, setScrollDirection] = useState('you have not scrolled yet')
  const [statusCheckPoint, setStatusCheckPoint] = useState(false)
  const [y, setY] = useState(document.scrollingElement ? document.scrollingElement.scrollHeight : 0)

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection('scrolling up')
      } else if (y < window.scrollY) {
        setScrollDirection('scrolling down')
      }
      setY(window.scrollY)
    },
    [y]
  )

  const handleScroll = () => {
    if (contentRef.current) {
      const bottom = contentRef.current.scrollHeight - contentRef.current.scrollTop <= contentRef.current.clientHeight
      setStatusCheckPoint(bottom)
      if (bottom) {
        setScrollDirection('Scrolled to bottom')
      }
    }
  }

  useEffect(() => {
    let WindowInner = window.innerHeight * 0.7
    handleScroll()
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        // You can send the file content to the next page or process it as needed
        onNextPage(state_action.previewimage, _.replace(e.target.result, 'data:image/jpeg;base64,', ''))
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSubmit = () => {
    alert('Consent Submitted!')
    toggleNestedModal()
    toggleMainModal()
  }

  const onCheckTypeModal = () => {
    if (typemodal == 'CAMARA') {
      onNextPage(state_action.camerainfo, null)
    } else {
      const checkDevice = handleDeviceDetection()
      if (checkDevice === device_type.Mobile) {
        window.ktaxaocr.callcheck(
          'PICKUPIMAGE',
          function(response) {
            window.ktaxaocr.pickerbookbank(
              (base64Image) => {
                onNextPage(state_action.previewimage, base64Image)
              },
              (error) => {
                console.error('checkDevice error:', error)
              }
            )
          },
          function(error) {
            console.error('onCheckTypeModal error :', error)
          }
        )
      } else {
        fileInputRef.current.click()
      }
    }
  }

  return (
    <>
      <div style={{ width: '100%', height: window.innerHeight * 0.3 }}>{CreateImageSubTitle(Bookbank)}</div>
      <div style={{ width: '100%', height: window.innerHeight * 0.3 }}>
        {CreateTitle('ยินดีต้อนรับ คุณ ' + payerModalSelcted + ' สู่ E-KYC Solution')}
        {CreateDetails(
          'ขั้นตอนการตรวจสอบบัญชีสำหรับการสมัครหักชำระ หรือรับผลประโยชน์กรมธรรม์อัตโนมัติ เพื่อพิสูจน์ความเป็นเจ้าของบัญชี ก่อนดำเนินการสมัคร บริษัทฯ จำเป็นต้องใช้ข้อมูลของท่านในการตรวจสอบ โปรดทำตามขั้นตอนที่กำหนดไว้เพื่อความรวดเร็วในการตรวจสอบสมุดบัญชีธนาคาร'
        )}
      </div>

      <Modal isOpen={mainModal} toggle={toggleMainModal}>
        <ModalHeader toggle={toggleMainModal}>นโยบายความเป็นส่วนตัวและข้อกำหนดและเงื่อนไข</ModalHeader>
        <ModalBody>
          <div
            className="content"
            ref={contentRef}
            onScroll={handleScroll}
            style={{
              height: WindowHeight,
              overflowY: 'scroll',
              // border: '1px solid #ccc',
              padding: '10px',
            }}
          >
            <p>
              บริษัท กรุงไทย แอกซ่า ประกันชีวิต จำกัด (มหาชน) ได้ทำการเก็บ รวบรวม ใช้และเปิดเผยข้อมูลส่วนบุคคลของท่าน
              เพื่อวัตถุประสงค์เกี่ยวกับการระบุตัวตน
              และพิสูจน์ทราบตัวตนประกอบการพิจารณารับประกันภัยและบริการที่เกี่ยวข้องกับกรมธรรม์ ประกันภัย
              โดยข้อมูลดังกล่าวอาจมีการเปิดเผยต่อผู้ที่เกี่ยวข้อง ซึ่งมีมาตรการการคุ้มครองข้อมูลของท่านที่เหมาะสม
              บริษัทจะ เก็บข้อมูลของท่านไว้นานเท่าที่จำเป็น ทั้งนี้ ท่านมีสิทธิในการ เข้าถึง แก้ไข ระงับการใช้ ลบ
              โอนย้ายหรือคัดค้านข้อมูล ส่วนบุคคลของท่าน ภายใต้เงื่อนไขที่กฎหมายกำหนด
              ท่านสามารถอ่านรายละเอียดเพิ่มเติมได้ที่นโยบายความเป็นส่วนตัว
              (https://www.krungthai-axa.co.th/th/Privacy-Policy) และหากมีข้อสงสัยหรือต้องการใช้สิทธิข้างต้น
              สามารถติดต่อมา ยังเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลได้ที่อีเมล DPO@krungthai-axa.co.th
              ข้อกำหนดและเงื่อนไข
            </p>
            <p>
              บริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน)
              มีความจำเป็นที่จะต้องเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่าน เพื่อใช้ประกอบกระบวนการระบุตัวตน
              พิสูจน์ทราบตัวตน ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์ และ/หรือ บริการที่เกี่ยวข้อง ของท่าน บริษัท
              กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน). จึงมีความประสงค์ที่จะขอ ความยินยอมเพื่อเก็บรวบรวม ใช้
              และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหวของท่าน เพื่อใช้ประกอบกระบวนการระบุตัวตน
              พิสูจน์ทราบตัวตน ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์ และ/หรือ บริการที่เกี่ยวข้องของท่าน โดย
              บริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน) อาจมอบหมายให้ ผู้ให้บริการภายนอก ตัวแทน ผู้รับจ้างช่วง
              เป็นผู้ดำเนินการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่านแทน บริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน)
              ในฐานะผู้ประมวลผลของบริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน) โดย บริษัท กรุงไทย แอกซ่า ประกันชีวิต
              จํากัด (มหาชน) มีการจัดเก็บรวบรวมข้อมูลดังกล่าวที่คลาวด์เซิร์ฟเวอร์อยู่ที่ประเทศสิงค์โปร์
              เก็บรวมรวมและใช้ข้อมูลส่วนบุคคลของข้าพเจ้าที่เกี่ยวข้องกับ การระบุตัวตน พิสูจน์ทราบตัวตน ของข้าพเจ้า
              ได้แก่ ชื่อ-นามสกุล ที่อยู่ วันเดือนปีเกิด หมายเลขประจำตัวประชาชน หมายเลขเลเซอร์หลังบัตรประชาชน อายุ
              เบอร์โทรศัพท์ ภาพถ่าย เพื่อดำเนินการตรวจสอบ ตัวตน พิสูจน์ทราบตัวตน
              ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์ สำหรับใช้ประกอบกระบวนการระบุตัวตน พิสูจน์ทราบตัวตน
              ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์ และ/หรือ บริการที่เกี่ยวข้องของข้าพเจ้า
              เก็บรวมรวมและใช้ข้อมูลส่วนบุคคลที่อ่อนไหว ซึ่งได้แก่ ข้อมูลใบหน้า ของข้าพเจ้า เพื่อดำเนินการระบุตัวตน
              พิสูจน์ทราบตัวตน ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์ และ/หรือ
              บริการที่เกี่ยวข้องของข้าพเจ้าให้บริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน)
              เปิดเผยและนำส่งข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่อ่อนไหวของข้าพเจ้า ให้แก่ ผู้ให้บริการภายนอก ตัวแทน
              ผู้รับจ้างช่วง
              เพื่อให้บุคคลดังกล่าวมีอำนาจดำเนินการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลอ่อนไหวของข้าพเจ้าในการตรวจสอบ
              การระบุตัวตน พิสูจน์ทราบตัวตนแทน บริษัท กรุงไทย แอกซ่า ประกันชีวิต จํากัด (มหาชน) โดยผู้ให้บริการภายนอก
              ตัวแทน ผู้รับจ้างช่วงจะส่งมอบข้อมูลการระบุตัวตน พิสูจน์ทราบตัวตนให้แก่ บริษัท กรุงไทย แอกซ่า ประกันชีวิต
              จํากัด (มหาชน) เพื่อดำเนินการระบุตัวตน พิสูจน์ทราบตัวตน ว่าข้อมูลดังกล่าวเป็นความจริงถูกต้องสมบูรณ์
              และ/หรือ บริการที่เกี่ยวข้องของข้าพเจ้า ข้าพเจ้ารับทราบว่า
              ข้าพเจ้ามีสิทธิที่จะเพิกถอนความยินยอมตามหนังสือฉบับนี้ได้ตลอดเวลา โดยแจ้งให้บริษัท กรุงไทย แอกซ่า
              ประกันชีวิต จํากัด (มหาชน) ทราบเป็นลายลักษณ์อักษร
              โดยข้าพเจ้าเข้าใจดีว่าสิทธิในการเพิกถอนความยินยอมดังกล่าวอาจถูกจำกัดโดยกฎหมายหรือสัญญาใดซึ่งเป็นประโยชน์ต่อข้าพเจ้า
              ทั้งนี้ การเพิกถอนความยินยอมของข้าพเจ้า จะไม่ส่งผลต่อการเก็บรวบรวม ใช้
              และ/หรือเปิดเผยข้อมูลข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อวัตถุประสงค์หรือการดำเนินการอื่น ๆ
              ซึ่งข้าพเจ้าได้ให้ความยินยอมแล้ว
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <div
            style={{
              width: window.innerWidth,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              color="primary"
              style={{
                width: window.innerWidth * 0.8,
              }}
              onClick={toggleNestedModal}
              // disabled={!statusCheckPoint}
            >
              ยินยอม
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      <div
        style={{
          width: '100%',
          height: window.innerHeight * 0.3,
          paddingLeft: '5%',
          paddingRight: '5%',
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyItems: 'center',
            fontSize: '18px',
          }}
        >
          <div>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              style={{ marginRight: '5px' }}
            />
          </div>
          <div>
            <span>
              คุณได้ยินยอมตาม{' '}
              <span style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => setMainModal(true)}>
                ข้อตกลงการยืนยันตัวตนตามนโยบายความเป็นส่วนตัวและข้อกำหนดและเงื่อนไข ต่างๆที่กำหนดไว้
              </span>
              ต่างๆที่กำหนดไว้
            </span>
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          {/* <Button
            style={{ width: '100%' }}
            outline={false}
            onClick={onCheckTypeModal}
            disabled={!isChecked}
          >
            ยืนยัน
          </Button> */}

          <Button
            style={{
              width: '100%',
              height: '45px',
            }}
            outline={false}
            onClick={() => onCheckTypeModal()}
            disabled={!isChecked}
          >
            {typemodal == 'CAMARA' || isChecked == false ? (
              <>ยืนยัน</>
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '45px',
                  display: 'flex',
                  // justifyContent: 'center',
                  // alignItems: 'center',
                }}
              >
                <div
                  style={{
                    width: '20%',
                    height: '90%',
                  }}
                >
                  <img src={iconCamara} style={{ width: '20px' }} />
                </div>
                <div
                  style={{
                    // marginTop: '5px',
                    width: '80%',
                    height: '90%',
                    // paddingTop: '2px',
                  }}
                >
                  เลือกจากคลังภาพ
                </div>
              </div>
            )}
          </Button>
        </div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
          accept="image/*"
          capture="filesystem"
          // capture="environment"
        />
      </div>
    </>
  )
}

export default ConsentAllow
